import { Component, OnInit,Input,EventEmitter,Output,ViewChild, ElementRef,Directive,HostListener} from '@angular/core';
import{ContentManagementService} from '../../../Services/content-management/content-management.service';
import { AnswerChoiceModel } from 'src/app/Models/AnswerChoiceModel';
import { QuestionStatusModel } from 'src/app/Models/QuestionStatusById';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VAddAnswerChoice } from 'src/app/Validators/Validators';
import { ToastrService } from "ngx-toastr";
import { VStudyMaterial } from 'src/app/Validators/Validators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HttpClient, HttpRequest, HttpEvent, HttpHeaders} from '@angular/common/http';
// import { TokenStorageService } from 'src/app/_services/token-storage.service';
import { StudyMaterialModel } from 'src/app/Models/StudyMaterial';
// import { ApiheadersService } from 'src/app/service/apiheaders.service';
import { ContentStatusModel } from 'src/app/Models/ContentStatus';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-content-reviewcomments',
  templateUrl: './content-reviewcomments.component.html',
  styleUrls: ['./content-reviewcomments.component.css'],
})
@Injectable()
export class ContentReviewcommentsComponent implements OnInit {
  InsertContentReview: ContentStatusModel;
  AddContentReviewform: FormGroup;
  @Input() subjectById: any;
  @Input() studymateriallist1: any;
  @Input() ScreenName1: string;
  @Input() StudymaterialFormvalue1: any;
  @Output() returnreviewclosebutton: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() ClickContentstatus: EventEmitter<any> = new EventEmitter<any>();
  pdfSrc: string;
  Filename: string;
  FileType: any;
  urlSafe: any;
  urlSafe1: SafeUrl;
  prev_url: any;
  assetURL: string;
  Status: string;
  File_Name: string;
  RTEFlag: string = 'Commentbox';
  QuestionBodyget: string;
  // static currentstudymaterialstatus: any;
  //static currentstudymaterialstatus: any;
  // @HostListener('contextmenu', ['$event'])

  // onRightClick(event) {    event.preventDefault();  }

  // viewer = 'google';

  // selectedType = 'docx';
  constructor(
    private sanitizer: DomSanitizer,
    public service: ContentManagementService,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    this.RTEFlag = 'Commentbox';
  }
  InitializeForm() {
    this.AddContentReviewform = this.fb.group({
      Study_Material_Name: [''],
      Comment_Text: ['', VStudyMaterial],
    });
  }
  ngOnInit() {
    this.InitializeForm();
    this.getBreadcrumbDetails();
    this.AddContentReviewform.controls['Study_Material_Name'].setValue(
      this.studymateriallist1.Study_Material_Name
    );
    this.Descriptioncount();
    this.GetContentStatusID(this.studymateriallist1.Study_Material_Status_Id);
    this.Status = this.studymateriallist1.Study_Material_Status_Type_Code;
    this.getStudyMaterial(this.studymateriallist1.Study_Material_Id);
    this.Filename = this.studymateriallist1.File_Location_Name;
    this.FileType = this.studymateriallist1.File_Type_Name;
    this.File_Name =
      'Study Material Name : ' + this.studymateriallist1.Study_Material_Name;
    // if(this.FileType=='Video'){
    //   if(this.StudymaterialFormvalue1.File_Location_Name!=null&&this.StudymaterialFormvalue1.File_Location_Name!=""){
    //     if(this.Filename!=null&&this.Filename!=""){
    //       this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.Filename);
    //     }
    //   }
    //   else{
    //     if(this.Filename!=null&&this.Filename!=""){
    //       this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.Filename);
    //     }
    //   }

    // }
    // else{
    //   this.Filename=this.studymateriallist1.File_Location_Name;
    // }

    if (this.FileType == 'Video') {
      if (this.Filename != null && this.Filename != '') {
        //this.urlSafe= this.Filename;
        if (this.File_Name == 'External URL') {
          this.urlSafe1 = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.Filename
          );
          //this.urlSafe= this.Filename;
          console.log(this.urlSafe1, 'urlSafe1');
        } else {
          this.urlSafe1 = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.Filename
          );
          //this.urlSafe= this.Filename;
        }
      }
    } else {
      if (this.Filename != null && this.Filename != '') {
        this.urlSafe = new URL(environment.apiBaseUrl).origin +
          this.studymateriallist1.File_Location_Name +
          '/' +
          (this.studymateriallist1.File_Name_In_Server || '');
        this.pdfSrc = this.Filename;

        // this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.Filename);
      }
    }

    // if(this.FileType=='Video'){
    //   if(this.StudymaterialFormvalue.File_Location_Name!=null&&this.StudymaterialFormvalue.File_Location_Name!=""){
    //     this.Filename=this.StudymaterialFormvalue.File_Location_Name;
    //   }
    //   else{
    //     this.Filename=this.studymateriallist.File_Location_Name;
    //   }

    // }
    // else{
    //   this.Filename=this.studymateriallist.File_Location_Name;
    // }
    // if(this.FileType=='Video'){
    //   this.urlSafe= this.Filename;
    // }
    // else{
    //   this.urlSafe= this.Filename;
    // }
    this.RTEFlag = 'Commentbox';
  }

  // ContentStatusList:any;
  // Content:any;
  // GetContentStatusID(data:any){

  //   this.service.GetContentStatusByID({'Study_Material_Status_Id':data,'IncludeReasonNotSelectedInd':'N'}).then((i:any)=>{
  //     this.Content=i;
  //     this.ContentStatusList=this.Content.StudyMaterialByID;
  //     if(this.ContentStatusList[0].Study_Material_Status_ID!=null){
  //     this.AddContentStatusform.controls['Study_Material_Name'].setValue(this.selectedContentById.Study_Material_Name);
  //     }

  //   }).catch((e:any)=>{
  //     this.ContentStatusList=null;
  //   });
  // }

  videoPlayer: HTMLVideoElement;

  @ViewChild('videoPlayer') videoplayer: ElementRef;

  toggleVideo() {
    this.videoplayer.nativeElement.play();
  }

  Breadcrumblist: any;
  Breadcrumb: string;
  getBreadcrumbDetails() {
    //  this.service.getBreadcrumbDetails({ 'ID': this.subjectById.Subject_Id }).subscribe((i: any) => {
    //    this.Breadcrumblist = i;
    this.service
      .getBreadcrumb({
        ID: this.studymateriallist1.Study_Unit_Id,
        Screenname: 'CONTENT_MANAGEMENT',
      })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          this.Breadcrumb = this.Breadcrumblist.Data;
        },
        (error) => {
          console.log(error);
        }
      );
    // }, error => {  console.log(error) }
    // );
  }

  StudyMateriallist: any;
  StudyMaterial: any;
  public static currentstudymaterialstatus: any;
  getStudyMaterial(data: any) {
    this.service.GetStudyMaterial({ Study_Material_Id: data }).subscribe(
      (i: any) => {
        this.StudyMaterial = i;
        this.StudyMateriallist = this.StudyMaterial.StudyMaterialByID;
        this.studymateriallist1 = this.StudyMateriallist[0];
        ContentReviewcommentsComponent.currentstudymaterialstatus =
          this.studymateriallist1;
        // }).catch((e: any) => {
        //   this.StudyMateriallist = null;
        // }
        // )
      },
      (error) => {
        console.log(error);
      }
    );
  }

  ContentStatusList: any;
  Content: any;

  GetContentStatusID(data: any) {
    this.service
      .GetContentStatusByID({
        Study_Material_Status_Id: data,
        IncludeReasonNotSelectedInd: 'N',
      })
      .subscribe(
        (i: any) => {
          this.Content = i;
          this.ContentStatusList = this.Content.StudyMaterialByID;
          if (
            this.ContentStatusList[0].Study_Material_Status_ID != null &&
            this.ContentStatusList[0].Study_Material_Status_Type_Code ==
              'Under Review'
          ) {
            this.AddContentReviewform.controls['Comment_Text'].setValue(
              this.ContentStatusList[0].Comment_Text
            );
            this.QuestionBodyget = this.ContentStatusList[0].Comment_Text;
          }

          // }).catch((e:any)=>{
          //   this.ContentStatusList=null;
          // });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  save_submitted: boolean = false;
  QuestionQuestionResponse: any;
  Modalclose: boolean;
  ReviewReasons: any;
  AddContentStatus() {
    //this.checkboxvalidation();
    if (this.AddContentReviewform.valid) {
      this.InsertContentReview = this.AddContentReviewform.value;
      this.InsertContentReview.Study_Material_Status_ID =
        this.studymateriallist1.Study_Material_Status_Id;
      this.InsertContentReview.Study_Material_Status_Type_Code = 'Under Review';
      this.InsertContentReview.Study_Material_ID =
        this.studymateriallist1.Study_Material_Id;

      //  else{
      //   let UDTReason = [];
      //   let list: any = {};
      //   list["ReviewActionReasonTypeCode"] = 'DifficultyLevel';
      //   UDTReason.push(list);
      //   this.InsertQuestionStatus.UDTQuestionReviewActionReason=UDTReason;
      //  }
      this.service
        .CreateOrModifyStudyMaterialStatus(this.InsertContentReview)
        .subscribe(
          (i: any) => {
            this.QuestionQuestionResponse = i;
            if (this.QuestionQuestionResponse.Message == 'Success') {
              this.toastr.success(
                'Study Material Status Added Successfully',
                '',
                {
                  timeOut: 500,
                }
              );
              this.save_submitted = false;
              //this.GetContentStatusID(this.studymateriallist1.Study_Material_Status_Id);
              this.getStudyMaterial(this.studymateriallist1.Study_Material_Id);
            } else {
              this.toastr.error(this.QuestionQuestionResponse.Message);
            }
            //  }).catch((e:any)=>{

            //  }
            //  )
          },
          (error) => {
            this.QuestionQuestionResponse = error;
            this.toastr.error(this.QuestionQuestionResponse.Message);
            this.save_submitted = false;
            console.log(error);
          }
        );
    }
  }

  Cancel() {
    this.returnreviewclosebutton.emit(1);
  }

  Descriptionvaluelength: any;
  DescriptionMaxlength: any;
  Descriptioncount() {
    this.DescriptionMaxlength = 4000;
    if (
      this.AddContentReviewform.controls.Comment_Text.value != '' &&
      this.AddContentReviewform.controls.Comment_Text.value != null
    ) {
      if (this.AddContentReviewform.controls.Comment_Text.value.length > 0) {
        this.Descriptionvaluelength =
          this.AddContentReviewform.controls.Comment_Text.value.length;
      } else {
        this.Descriptionvaluelength = 0;
      }
    } else {
      this.Descriptionvaluelength = 0;
    }
  }

  AddSubmitReview(data: any) {
    let list = {
      Content_status: data,
      Content: this.studymateriallist1,
      Content_text: this.AddContentReviewform.controls.Comment_Text.value,
    };
    this.ClickContentstatus.emit(list);
  }

  // Contentstatus:any;
  // selectedContentById:any;
  // ClickContentstatus(data:any){
  //     this.selectedContentById=data.Content;
  //     this.Contentstatus=data.Content_status;
  //     this.Contentreview();
  //   }

  // Contentreviewpopupflag:boolean
  // Contentreview(){
  // this.Contentreviewpopupflag=!this.Contentreviewpopupflag;
  // }

  // ClkContentclose(){
  //   if(this.Contentreviewpopupflag){
  //     this.Contentreview();
  //   }
  // }
  // ReturnContentreviewclose(data:any){
  // this.ClkContentclose();
  // }

  //pdfSrc = "https://perfectlearningapp.azurewebsites.net//UploadFiles/History_Post_Mauryan_Period_The_Gupta_Dynasty_Study_Unit_1_ENG_Perfect_Learning_Screen_Requirements.pdf";
  //pdfSrc1 = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  zoom_scale: number = 0.9;
  Rotate: number = 0;
  zoom(key: Number): void {
    let zoom: Number = 0;
    if (key == 1) {
      zoom = Number(this.zoom_scale) + Number(0.1);
    }
    if (key == 0) {
      zoom = Number(this.zoom_scale) - Number(0.1);
    }
    if (zoom > 0 || zoom < 1.5) {
      this.zoom_scale = Number(zoom);
    }
  }
  Rotation() {
    if (Number(this.Rotate) == 0) {
      this.Rotate = 90;
    } else if (Number(this.Rotate) == 90) {
      this.Rotate = 180;
    } else if (Number(this.Rotate) == 180) {
      this.Rotate = 0;
    }
  }

  comments: string;
  GetCommentboxContent(data: any) {
    this.comments = data;
    //if(this.QuestionBodyContent!=null)

    this.AddContentReviewform.controls['Comment_Text'].setValue(this.comments);
  }

  //rating
  ContentRatingflag: boolean = false;
  Rating() {
    this.ContentRatingflag = !this.ContentRatingflag;
  }

  Closepopup(data: any) {
    if (this.ContentRatingflag) {
      this.Rating();
    }
  }
}
